import './Psychward.css';
import { Link } from 'react-router-dom'
import { useTheme } from '../../hooks/useTheme'


function Psychward() {
  const { mode } = useTheme()

  return (
    <div className={`psychward-game ${mode}`}>
         <div className='breadcrumbs'>
          <Link to="/">
              <div className='link-crumb'>/Home </div>
          </Link>
          <Link to="/games">
              <div className='link-crumb'> /Games </div>
          </Link>
          <div className='link-crumb'> /Psychward The Game</div>
      </div>
      <h1>Psychward The Game</h1>
      <h3>-- A Visual Novel --</h3>
      <p>A simulation game: experience a stay in the psych ward as told by a mentally ill patient.</p>
      <p>© CF Games 2025</p>
      <a href='https://clairecodes.itch.io/psych-ward-the-game-a-visual-novel' target="_blank" rel="noreferrer">View on itch.io site</a>
      <div className='game-container'>
        <iframe frameborder="0" src="https://itch.io/embed/3331854" width="552" height="167"><a href="https://clairecodes.itch.io/psych-ward-the-game-a-visual-novel">Psych Ward The Game - A Visual Novel by clairecodes</a></iframe>
      </div>
      <Link to="/games">
         <div className='link'>&#8592; Back to all Games</div>
       </Link>
    </div>
  );
}

export default Psychward;